module.exports = __webpack_public_path__ + "img/T5-D-rc_15.1797a5d4.png";